import { isLogging } from "../globals/isLogging";

export const logger = (message: string, ...optionalParams: any[]) => {
  if (isLogging.value) {
    console.log(message, ...optionalParams);
  }
}